import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { DocumentData, DocumentType } from '@cp/pages/CaseDetails/components/AllDocumentsV2/types';
import groupBy from '@cp/utils/groupBy';
import PdfDocument from '@cp/pages/CaseDetails/components/AllDocumentsV2/components/PdfDocument';
import { noop } from '@utils/common';
import VideoRenderer from '@cp/pages/CaseDetails/components/AllDocumentsV2/components/VideoRenderer';
import { GridRow } from '@navi/web-ui/lib/layouts/Grid';
import { fileTypeToLabel } from '@cp/pages/CaseDetails/components/AllDocumentsV2/utils';
import ImageRenderer from '@cp/pages/CaseDetails/components/AllDocumentsV2/components/ImageRenderer';
import DynamicDocumentRenderer from '@cp/pages/CaseDetails/components/AllDocumentsV2/components/DynamicDocumentRenderer';
import { DocContentType } from '@cp/pages/CaseDetails/components/AllDocumentsV2/types';
import { GenericObject } from '@cp/src/types/CommonConstans';
type DynamicDocumentTabProps = {
  documentTabKey: string;
};
function DynamicDocumentTab({ documentTabKey }: DynamicDocumentTabProps) {
  const documents = useSelector(
    (state: RootState) => state.documentSlice?.documents?.documentDetails?.[documentTabKey]
  ) as DocumentType;

  const groupedCategories: Record<DocContentType, GenericObject> = groupBy(
    documents?.documentsData,
    (document: DocumentData) => {
      if (document?.docContentType?.includes('image')) {
        return 'image';
      }
      if (document?.docContentType?.includes('pdf')) {
        return 'pdf';
      }
      if (document?.dynamicallyGenerated) {
        return 'pdf';
      }
      if (document?.documentType?.includes('VKYC_VIDEO')) {
        return 'video';
      }
      if (document?.documentType?.includes('SELFIE')) {
        return 'image';
      }
      if (document?.docContentType?.includes('octet-stream')) {
        return 'pdf';
      }
      return 'other';
    }
  );
  return (
    <>
      {Object.keys(groupedCategories)
        .sort()
        .map(key => (
          <div key={key} className="p-4">
            <div className="mb-3 text-[--grayscale-content-2]">
              {fileTypeToLabel(key as DocContentType)}
            </div>
            <GridRow className="gap-5 w-full flex-wrap mb-4 ml-0">
              {/*@ts-expect-error group categrories need to be solved */}
              {groupedCategories[key].map((doc: DocumentData) => {
                if (key === DocContentType.IMAGE) {
                  return (
                    <div key={doc?.uri} className="pl-0">
                      <ImageRenderer
                        className="w-[fill-available] object-contain height-[163px]"
                        src={doc?.uri}
                        alt={doc?.documentName}
                        key={doc.documentType}
                        name={doc?.documentName}
                      />
                    </div>
                  );
                }
                if (doc?.dynamicallyGenerated) {
                  return (
                    <div key={doc?.uri} className="pl-0">
                      <DynamicDocumentRenderer
                        key={doc?.uri}
                        type={'pdf'}
                        uri={doc?.uri}
                        documentName={doc?.documentName}
                        documentType={doc?.documentType}
                        isDynamic={true}
                      />
                    </div>
                  );
                }
                if (key === DocContentType.PDF) {
                  return (
                    <div key={doc?.uri} className="pl-0">
                      <PdfDocument
                        key={doc?.uri}
                        type={'pdf'}
                        uri={doc?.uri}
                        documentName={doc?.documentName}
                        isLoading={false}
                        isDynamic={false}
                        generateDocument={noop}
                      />
                    </div>
                  );
                }
                // if (key == DocContentType.VIDEO) {
                //   return <VideoRenderer key={doc?.uri} uri={doc?.uri} />;
                // }
              })}
            </GridRow>
          </div>
        ))}
    </>
  );
}
export default DynamicDocumentTab;
